export default function printWindow(e) {
  e && e.preventDefault(); // eslint-disable-line no-unused-expressions
  window && window.print(); // eslint-disable-line no-unused-expressions
}
